import React, { Component } from 'react';
import AnimatedNumber from 'react-animated-number';
import CalculatorModal from './CalculatorModal';
import EventModal from './EventModal';
import CapModal from './CapModal';
import ChartModal from './ChartModal';
import Pundi from './Pundi.png';
import PundiLarge from './PundiLarge.webp';
import CoinId from './CoinId.json';
import TechnicalAnalysis,{ THEMES, INTERVALS} from 'react-tradingview-technical-analysis';




//var apiKey = "c0de896bb4dc62341cd2590ab7cd8a3231e7614493cd395852d41c7cdd9f293d";
let AverageDev = 0;
let prevAverageDev = 0;
let movingAverage = 0;
let prevMovingAverage = 0;
var numeral = require('numeral');
var cryptocurrencies = require('cryptocurrencies');
let footer = '';
let button='';

let m = '';
let locked = false;

class CryptoCard extends Component {
    constructor(props) {
    super(props);
		this.state = {
            loading: false,	
            	
            Open:[],
            Close:[],
            Time:[],
            High:[],
            Low:[],
            typical:[],
            movingAverage:0,
            prevMovingAverage:0,

            numDays:20,
            standardDev:2,
            
            Deviation:[],
            UpperBand:null,
            LowerBand:null,
            BBwidth:0,

            prevDeviation:[],
            prevUpperBand:null,
            prevLowerBand:null,
            prevBBWidth:null,
            //isCoin:false,

            price:0,
            prevPrice:null,
            modalOpen:false,
            eventOpen:false,
            capOpen:false,
            chartOpen:false,
            logo:null,
            website:null,
            marketCap:null,
            chart:false,
            charts:false,
            current:1505,
            coinChart:null,
            twitter:null,
        };
        this.add=this.add.bind(this);
    }
    componentDidMount() {
        this._isMounted = true;
        this.getLogo();
       // this.getMarketCap();
        
        this.getWebSocket();
        this.getPrice();
    }

    componentDidUpdate(prevProps, prevState) {
        if(prevProps.currency!==this.props.currency){
          this.setState({
            chart:false,
            price:0
          },()=>this.getWebSocket());

          this.getPrice(); 
        }

        if(prevProps.time!==this.props.time){
            
    
            this.getPrice();
          }


        if(prevProps.locked!==this.props.locked){
            locked = this.props.locked
    
            
          }


        if(prevProps.coin!==this.props.coin){
            this.setState({
                price:0
              },()=>this.getLogo());
    
            
            this.getWebSocket();
           // this.getMarketCap();
            this.getPrice();
            
        }

        if(prevProps.message!==this.props.message){
            
            let percentage = 5/100*this.state.UpperBand
            this.getWebSocket();
            if(this.props.time === 'histoday'){
            if(this.state.price !== 0 && percentage !== 0 && this.state.UpperBand !== null && percentage == 5/100*this.state.UpperBand && this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.7 && this.state.BBwidth *100 > 1 && this.state.BBwidth *100 < 25 && !this.props.locked){
                //Previous Value=> 10,15//
                this.props.green.findIndex(x =>x[0] !== undefined && x[0] == this.props.coin +'-'+ this.props.currency) === -1 && this.props.green.push([this.props.coin +'-'+ this.props.currency,numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00'),this.props.coin +'_'+ this.props.currency,numeral(this.state.BBwidth * 100).format('0,0.00'),(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,1115,this.state.twitter]);

            }
            else if( this.state.price !== 0 && percentage !== 0 && this.state.UpperBand !== null && percentage == 5/100*this.state.UpperBand && this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.7 && this.state.BBwidth *100 > 25 && this.state.BBwidth *100 < 40 && !this.props.locked){
                //Previous Value=> 10,15//
                this.props.blue.findIndex(y =>y[0] !== undefined && y[0] == this.props.coin +'-'+ this.props.currency) === -1 && this.props.blue.push([this.props.coin +'-'+ this.props.currency,numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00'),this.props.coin +'_'+ this.props.currency,numeral(this.state.BBwidth * 100).format('0,0.00'),(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,1115,this.state.twitter]);

               
                }
            }
            else{
                if(this.state.price !== 0 && percentage !== 0 && this.state.UpperBand !== null && percentage == 5/100*this.state.UpperBand && this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.2 && this.state.BBwidth *100 < 15 && !this.props.locked){
                    //Previous Value=> 10,15//
                    this.props.green.findIndex(x =>x[0] !== undefined && x[0] == this.props.coin +'-'+ this.props.currency) === -1 && this.props.green.push([this.props.coin +'-'+ this.props.currency,numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00'),this.props.coin +'_'+ this.props.currency,numeral(this.state.BBwidth * 100).format('0,0.00'),(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,1115,this.state.twitter]);
    
                }
                else if( this.state.price !== 0 && percentage !== 0 && this.state.UpperBand !== null && percentage == 5/100*this.state.UpperBand && this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.2 && this.state.BBwidth *100 > 10 && this.state.BBwidth *100 < 30 && !this.props.locked){
                    //Previous Value=> 10,15//
                    this.props.blue.findIndex(y =>y[0] !== undefined && y[0] == this.props.coin +'-'+ this.props.currency) === -1 && this.props.blue.push([this.props.coin +'-'+ this.props.currency,numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00'),this.props.coin +'_'+ this.props.currency,numeral(this.state.BBwidth * 100).format('0,0.00'),(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,1115,this.state.twitter]);
    
                    }
                    

            }
        }
      }

    

    componentWillUnmount() {
		this._isMounted = false;
	}
    
    
    getWebSocket(){
        
        let message = this.props.message
        let percentage = 5/100*this.state.UpperBand
        if(message.PRICE !== undefined && message.FROMSYMBOL === this.props.coin){
            this.setState({prevPrice:this.state.price,price:message.PRICE},()=>console.log())

         }
  
    }

    getStatus(){
       
    }

    async getPrice(){
        this.setState({Open:[],
            Close:[],
            High:[],
            Low:[],

            typical:[],
            Deviation:[],
            UpperBand:null,
            LowerBand:[],
            BBwidth:null,

            prevDeviation:[],
            prevUpperBand:[],
            prevLowerBand:[],
            prevBBWidth:null,
            currentPrice:null,
            

        },()=>console.log()) 

        
         
        let url = 'https://min-api.cryptocompare.com/data/v2/'+this.props.time+'?fsym='+ this.props.coin +'&tsym=' +this.props.currency+'&limit=20&api_key='+this.props.apiKey
        //let url = 'https://min-api.cryptocompare.com/data/v2/histoday?fsym=BTC&tsym=USD&limit=20&api_key=156c5da04db8726ab5fd90a2a789e4fe78cf40307f8ac2038ae9c17532ae0624'
		fetch(url)
			  .then(res => res.json())
			  .then((data) => {
				if (this._isMounted){

                    let x = data.Data.Data
                
                    for(var i = 0; i < 21; i++){
                     this.setState({Open:[...this.state.Open,x[i].open],
                        Close:[...this.state.Close,x[i].close],
                        High:[...this.state.High,x[i].high],
                        Low:[...this.state.Low,x[i].low],
                        

                        typical:[...this.state.typical,(x[i].high + x[i].low + x[i].close) / 3],
                    }) 
                       
                    }
            var total = 0;
            var prevTotal = 0;
             //
            for(var f = 0; f < this.state.Close.length; f++) {
            total += this.state.Close[f];
            }
            this.setState({movingAverage:total/this.state.Close.length},()=>console.log())

            movingAverage = total / this.state.Close.length;

            for(var y = 0; y < this.state.Close.length-1; y++) {
                prevTotal += this.state.Close[y];
                }
            this.setState({prevMovingAverage:prevTotal/(this.state.Close.length-1)},()=>console.log())
    
            prevMovingAverage = prevTotal / (this.state.Close.length-1);
            //
            
            for(var m = 0; m < this.state.Close.length; m++) {
            this.setState({Deviation:[...this.state.Deviation,(this.state.Close[m] - movingAverage) * (this.state.Close[m] - movingAverage)]},()=>console.log())
             } 

            for(var u = 0; u < this.state.Close.length-1; u++) {
            this.setState({prevDeviation:[...this.state.prevDeviation,(this.state.Close[u] - prevMovingAverage) * (this.state.Close[u] - prevMovingAverage)]},()=>console.log())
                } 
            }

            let totalPrevDev = 0;
            for(var z = 0; z < this.state.prevDeviation.length; z++) {
            totalPrevDev += this.state.prevDeviation[z];
            }
            prevAverageDev = Math.sqrt(totalPrevDev / this.state.prevDeviation.length);
                this.setState({prevUpperBand:prevMovingAverage + (2 * prevAverageDev),
                               prevLowerBand:prevMovingAverage - (2 * prevAverageDev),
                            },()=>this.setState({prevBBWidth:(this.state.prevUpperBand - this.state.prevLowerBand) / this.state.prevMovingAverage},()=>console.log()
                            ))

            
            let totalDev = 0;
            for(var n = 0; n < this.state.Deviation.length; n++) {
            totalDev += this.state.Deviation[n];
            }
            AverageDev = Math.sqrt(totalDev / this.state.Deviation.length);
                this.setState({UpperBand:movingAverage + (2 * AverageDev),
                               LowerBand:movingAverage - (2 * AverageDev),
                            },()=>this.setState({BBwidth:(this.state.UpperBand - this.state.LowerBand) / this.state.movingAverage},()=>console.log()
                            ))
                            
                            if(this.props.time === 'histoday'){
                            if( this.state.BBwidth !== null && this.state.BBwidth *100 < 15 && this.state.BBwidth < this.state.prevBBWidth && !this.props.locked){
                                this.props.red.findIndex(x =>x[0] !== undefined && x[0] == this.props.coin +'-'+ this.props.currency) === -1  && this.props.red.push([this.props.coin +'-'+ this.props.currency,numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00'),this.props.coin +'_'+ this.props.currency,numeral(this.state.BBwidth * 100).format('0,0.00'),(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,1115,this.state.twitter]);
                            }
                           
                            }
                            else {
                                if(this.state.BBwidth !== null && this.state.BBwidth *100 < 5 && this.state.BBwidth < this.state.prevBBWidth && !this.props.locked){
                                    this.props.red.findIndex(x =>x[0] !== undefined && x[0] == this.props.coin +'-'+ this.props.currency) === -1  && this.props.red.push([this.props.coin +'-'+ this.props.currency,numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00'),this.props.coin +'_'+ this.props.currency,numeral(this.state.BBwidth * 100).format('0,0.00'),(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,1115,this.state.twitter]);
                                }
                                
                            }   
                            
                           
            
              })  
              .catch(console.log)
           
    
      }

      async getLogo(){

  


     //  var cryptocurrencies = require('cryptocurrencies');
      //  let x =  await cryptocurrencies[this.props.coin]
      // if(x === undefined){
        let ID = CoinId.filter(coin => coin.name === this.props.coin)
        let x = ID[0].ID
      // }
        if(x !== undefined)
        fetch('https://api.coingecko.com/api/v3/coins/'+x+'?localization=false&tickers=false&market_data=false&community_data=false&developer_data=false&sparkline=false')
        .then(res => res.json())
        .then((data) => {
          if (this._isMounted && data !== undefined){
             // console.log("datass",data)
          this.setState({logo: data.image.small,logoLarge: data.image.large,website: data.links.homepage[0], twitter: data.links.twitter_screen_name},()=>(console.log()))}
        })
        .catch(console.log)
    
      }

      /*async getMarketCap(){
        let y = await cryptocurrencies[this.props.coin]
        if(y !== undefined)
        fetch('https://api.coingecko.com/api/v3/simple/price?ids='+y.replace(/\s+/g, '-').toLowerCase()+'&vs_currencies=usd&include_market_cap=true&include_24hr_change=ture&include_last_updated_at=ture')
              .then(res => res.json())
              .then((data) => {
                if (this._isMounted && data[y.replace(/\s+/g, '-').toLowerCase()].usd_market_cap !== undefined){
                this.setState({marketCap: data[y.replace(/\s+/g, '-').toLowerCase()].usd_market_cap},()=>console.log())}
              })
              .catch(console.log)
      }*/
      

      add=(coin,currency)=>{
        this.props.add(coin,currency) 
      }


      round(value){
        if (value){
            if(this.props.currency === 'USDT' ){
            return numeral(this.state.price).format('0,0.000');
            }
            else{
            return numeral(this.state.price).format('0,0.00000000');
            }
        }
        return 0;
    }

    
    chart(){
        let ID = CoinId.filter(coin => coin.name === this.props.coin)
        this.setState({coinChart:ID[0].slug},()=>console.log())
        if(this.props.currency === 'USDT'){
            this.setState({current:1505},()=>this.props.chartDisplay.push([this.state.coinChart,this.state.current,(this.props.coin + this.props.currency),false,this.props.coin]))
        }
        else if(this.props.currency === 'BTC'){
            this.setState({current:859},()=>this.props.chartDisplay.push([this.state.coinChart,this.state.current,(this.props.coin + this.props.currency),false,this.props.coin]))
        }
        else if(this.props.currency === 'ETH'){
            this.setState({current:145},()=>this.props.chartDisplay.push([this.state.coinChart,this.state.current,(this.props.coin + this.props.currency),false,this.props.coin]))
        }

        
        this.setState((prevState)=>{
            return {chart:!prevState.chart}
        })
       window.scrollTo(0,640); 
      
    }

    bothCharts(){
        let ID = CoinId.filter(coin => coin.name === this.props.coin)
        this.setState({coinChart:ID[0].slug},()=>console.log())
    
        this.props.chartDisplay_USD.push([this.state.coinChart,'USDT',(this.props.coin + 'USDT'),false,this.props.coin]);        
        
        this.setState((prevState)=>{
            return {chart:!prevState.chart}
        })
      // window.scrollTo(0,640); 
      
    }

    trade(){
       let ID = CoinId.filter(coin => coin.name === this.props.coin);
       let coinSlug = ID[0].slug;
    

       this.props.prevTrade((this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,coinSlug,this.state.twitter)
       this.bothCharts()
       //this.props.trade.push([(this.props.coin + '~' + this.props.currency),this.props.coin,this.props.currency,coinSlug])
       //this.props.enterTrade()
       //this.scroll((this.props.coin + '~' + this.props.currency))
    }

    scroll(hex){
        hex = document.getElementById(hex);
        //let name = this.props.coin + '~' + this.props.currency;
        let titleElement = document.getElementById(hex).value;
        let sting = hex.value
        console.log("string",titleElement)
        titleElement.scrollIntoView({ behavior: 'smooth' })
    }

    
    speak(coin, price){
        let ID = CoinId.filter(coins => coins.name === coin)
        let x = ID[0].ID

      if(m !== price){
        this.props.speakPrice(x,price)
      m = price
    }
    }

       
    render() {
        if(this.props.findPrice !== null && this.props.findPrice === this.props.coin){
        this.speak(this.props.coin,this.state.price)
        }
        let priceChange =  <div className='tooltipPositive'>0.00%</div>; 
        
        if(numeral(((this.state.price - this.state.Close[19]) / this.state.Close[19]) * 100).format('0,0.00') > 0.00){
            priceChange =  <div className='tooltipPositive'>{'+' + numeral(((this.state.price - this.state.Close[19]) / this.state.Close[19]) * 100).format('0,0.00')+'%'}</div>
        }
        else if(numeral(((this.state.price - this.state.Close[19]) / this.state.Close[19]) * 100).format('0,0.00') < 0.00){
        
            priceChange =  <div className='tooltipNegative'>{numeral(((this.state.price - this.state.Close[19]) / this.state.Close[19]) * 100).format('0,0.00')+'%'}</div>
        }
        let percentage = 0;
        let logo = Pundi;
        let logoLarge = PundiLarge;
        if(this.state.logo !== null){
            logo = this.state.logo;
            logoLarge = this.state.logoLarge;
        }
        else{
            logo = Pundi;
            logoLarge = PundiLarge;
        }
        let modalClose = () => this.setState({modalOpen:false})
        let modalOpen = () => this.setState({modalOpen:true})
        let eventClose = () => this.setState({eventOpen:false})
        let eventOpen = () => this.setState({eventOpen:true})
        let capClose = () => this.setState({capOpen:false})
        let capOpen = () => this.setState({capOpen:true})
        let chartClose = () => this.setState({chartOpen:false})
        let chartOpen = () => this.setState({chartOpen:true})

        let link = 'https://www.binance.com/en/trade/'+ this.props.coin +'_'+this.props.currency
        footer = '';
        button='';
        let cryptocard='cryptocard';
        let change='';
        let num=<div className="price">Price: <AnimatedNumber component="text" value={this.state.price} onClick={() => this.setState({ modalOpen:true})} style={{
            transition: '0.1s ease-out',
            fontSize: 17,
            cursor:'pointer',
            transitionProperty:
            'background-color, color, opacity'
        }}frameStyle={perc => (
            perc === 100 ? {} : {color: fontColor}
        )}
        duration={1500}
        formatValue={n=>this.round(n)}>Price: {this.state.price}</AnimatedNumber> {this.props.currency.slice(0,3)} {priceChange} </div>;
        percentage = 5/100*this.state.UpperBand
    

        let fontColor = 'rgb(245, 237, 237)';
        if(this.state.prevPrice < this.state.price){
            fontColor = 'rgb(98, 175, 34)';
        }
        else if(this.state.prevPrice > this.state.price){
            fontColor = 'rgba(230, 26, 60)';
        }
        else{
            fontColor = 'rgb(154, 236, 87)';
        }
       
        if(this.props.time === 'histoday'){
            if(this.state.BBwidth *100 < 15 && this.state.BBwidth < this.state.prevBBWidth){
               
                footer="footer1"
                button = <button className="add" onClick={()=>this.add(this.props.coin,this.props.currency)}></button>; 
                cryptocard="winner"     
                
            }
           else{
                footer="footer2"
            }
            
            
            if(percentage !== 0 && this.state.UpperBand !== null && percentage == 5/100*this.state.UpperBand && this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.7 && this.state.BBwidth *100 > 1 && this.state.BBwidth *100 < 25){
                //Previous Value=> 10,15//
                button = <button className="superb" onClick={()=>this.add(this.props.coin,this.props.currency)}></button>; 
                footer="footer3";
                cryptocard="super";

            }
            else if( percentage !== 0 && this.state.UpperBand !== null && percentage == 5/100*this.state.UpperBand && this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.7 && this.state.BBwidth *100 > 25 && this.state.BBwidth *100 < 40){
                //Previous Value=> 10,15//
                button = <button className="warning" onClick={()=>this.add(this.props.coin,this.props.currency)}></button>; 
               
            }

        }
        else{
            if(this.state.BBwidth  *100 < 5 && this.state.BBwidth < this.state.prevBBWidth){
                
                footer="footer1"
                button = <button className="add" onClick={()=>this.add(this.props.coin,this.props.currency)}></button>;
                //if(this.state.BBwidth < this.state.prevBBWidth){
                cryptocard="winner"
                //}  
            }else{
                footer="footer2"
            }

            if(this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.2 && this.state.BBwidth *100 < 15){
                //Previous Value=> 0.3,3//
                button = <button className="superb" onClick={()=>this.add(this.props.coin,this.props.currency)}></button>; 
                footer="footer3";
                cryptocard="super";
            }
            else if(this.state.price > this.state.UpperBand - percentage && this.state.price > this.state.movingAverage && (this.state.BBwidth - this.state.prevBBWidth ) * 100 > 0.2 && this.state.BBwidth *100 > 10 && this.state.BBwidth *100 < 30){
                //Previous Value=> 10,15//
                button = <button className="warning" onClick={()=>this.add(this.props.coin,this.props.currency)}></button>; 
                
            }
        }


        if(this.state.BBwidth > this.state.prevBBWidth){
            change =< div className="changeUp" title={'+'+numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00')+'%'}><i class="fas fa-arrow-up"></i></div>
        }  else{
            change = <div className="changeDown" title={numeral((this.state.BBwidth - this.state.prevBBWidth) * 100).format('0,0.00')+'%'}><i class="fas fa-arrow-down"></i></div>
        }

        //<div className="chart2"><div><iframe src={"https://widget.coinlib.io/widget?type=chart&theme=dark&coin_id=859&pref_coin_id=1505"} width="100%" height="330px" scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0" ></iframe></div></div>
       let body = ''
      
       body =  <div className={cryptocard} >
           

       <div className="header" > 
       {this.state.modalOpen&&<CalculatorModal
       show={modalOpen}
       onHide={modalClose}
       currency={this.props.currency}
       coinPrice={this.state.price}
       coinName={this.props.coin}
       aria-labelledby="ModalHeader"
   />}
    
    
       <div className="header" >
      
       {change}

       <a href={this.state.website} target="blank" className="links" title={cryptocurrencies[this.props.coin]}>
       <img src={logo} className="logoCard" alt=''/>
      
       </a>
       
       {button}
       
       </div>
        
       <div className="marketCap">
       <i class="fas fa-user-astronaut" title={'View Market Cap'}  onClick={() => this.setState({ capOpen:true})}></i>
       {this.state.capOpen&&<CapModal
       show={capOpen}
       onHide={capClose}
       coinName={this.props.coin}
       name={cryptocurrencies[this.props.coin]}
       logo={logoLarge}
       website={this.state.website}
       aria-labelledby="ModalHeader"
   />}
   </div>

   <div className="chartIcon"> 
       <i class="fas fa-dice-d20" onClick={() => this.setState({ chartOpen:true})}></i>
       {this.state.chartOpen&&<ChartModal
       show={chartOpen}
       onHide={chartClose}
       coinName={this.props.coin}
       name={cryptocurrencies[this.props.coin]}
       logo={logoLarge}
       website={this.state.website}
       aria-labelledby="ModalHeader"
   />}
       </div>
       <a href={link} target="blank" className="links" title="Open on Bittrex"> 
       {this.props.coin}-{this.props.currency.slice(0,3)}
       </a>
      
       </div>
       <div className="events" onClick={() => this.setState({ eventOpen:true})} title="See Upcoming News"><i class="fas fa-calendar-alt" ></i></div>
       {this.state.eventOpen&&<EventModal
       show={eventOpen}
       onHide={eventClose}
       coinName={this.props.coin}
       aria-labelledby="ModalHeader"
   />}

    <a className="twitter" href={"https://twitter.com/"+this.state.twitter} target="blank">
    <i class="fab fa-twitter"></i>
    </a>

       {num}   
       
          
       <div className={footer} onClick={()=>this.chart()}>Previous Width: {numeral(this.state.prevBBWidth * 100).format('0,0.00')}%</div>
       <div className={footer} onClick={()=>this.trade()}>Width: {numeral(this.state.BBwidth * 100).format('0,0.00')}%</div>
       
       
       </div>
      
      /*{this.state.chart &&<div className="cryptochart" title= {'High: '+numeral(this.state.UpperBand).format('0,0.000') +', Low: '+ numeral(this.state.LowerBand).format('0,0.000')} onClick={()=>this.chart()}>
               

                   <div className="chart2"> <iframe src={"https://widget.coinlib.io/widget?type=chart&theme=dark&coin_id="+this.state.coinChart+"&pref_coin_id="+this.state.current} width="100%" height="400px" scrolling="auto" marginwidth="0" marginheight="0" frameborder="0" border="0" ></iframe> </div>
        
        </div> }  */
             
        return (
            
            <div >



            {body}
            
           
            
         
            </div>
            
        );
    }
}

export default CryptoCard;